import {React, useEffect} from 'react'
import Tabs from './Tabs'
import hljs from 'highlight.js';
// import javascript from 'highlight.js/lib/languages/javascript';
// import "highlight.js/styles/github.css";
import 'highlight.js/styles/default.css';
import Clients from './Clients';
import {ClipboardIcon} from '@heroicons/react/24/outline'




const Developers = () => {



  return (
    <div className='bg-[#092540]'>


        <div class="  max-w-[85rem] px-8 py-24 sm:px-6 lg:px-8  lg:pb-20 mx-auto ">

{/* <Clients titleColor="text-gray-600" logoColor="text-gray-400" /> */}


  {/**  Grid */}
  <div class="relative md:grid md:grid-cols-2 md:items-center sm:py-20 md:gap-12 xl:gap-32">



 <span className="absolute top-4  left-4">
 <svg className='animate-ping' width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.5"><circle cx="40.9984" cy="1.49626" r="1.49626" transform="rotate(90 40.9984 1.49626)" fill="white"></circle><circle cx="27.8304" cy="1.49626" r="1.49626" transform="rotate(90 27.8304 1.49626)" fill="white"></circle><circle cx="14.6644" cy="1.49626" r="1.49626" transform="rotate(90 14.6644 1.49626)" fill="white"></circle><circle cx="1.49642" cy="1.49626" r="1.49626" transform="rotate(90 1.49642 1.49626)" fill="white"></circle><circle cx="40.9984" cy="14.6642" r="1.49626" transform="rotate(90 40.9984 14.6642)" fill="white"></circle><circle cx="27.8304" cy="14.6642" r="1.49626" transform="rotate(90 27.8304 14.6642)" fill="white"></circle><circle cx="14.6644" cy="14.6642" r="1.49626" transform="rotate(90 14.6644 14.6642)" fill="white"></circle><circle cx="1.49642" cy="14.6642" r="1.49626" transform="rotate(90 1.49642 14.6642)" fill="white"></circle><circle cx="40.9984" cy="27.8302" r="1.49626" transform="rotate(90 40.9984 27.8302)" fill="white"></circle><circle cx="27.8304" cy="27.8302" r="1.49626" transform="rotate(90 27.8304 27.8302)" fill="white"></circle><circle cx="14.6644" cy="27.8302" r="1.49626" transform="rotate(90 14.6644 27.8302)" fill="white"></circle><circle cx="1.49642" cy="27.8302" r="1.49626" transform="rotate(90 1.49642 27.8302)" fill="white"></circle><circle cx="40.9984" cy="40.9982" r="1.49626" transform="rotate(90 40.9984 40.9982)" fill="white"></circle><circle cx="27.8304" cy="40.9963" r="1.49626" transform="rotate(90 27.8304 40.9963)" fill="white"></circle><circle cx="14.6644" cy="40.9982" r="1.49626" transform="rotate(90 14.6644 40.9982)" fill="white"></circle><circle cx="1.49642" cy="40.9963" r="1.49626" transform="rotate(90 1.49642 40.9963)" fill="white"></circle><circle cx="40.9984" cy="54.1642" r="1.49626" transform="rotate(90 40.9984 54.1642)" fill="white"></circle><circle cx="27.8304" cy="54.1642" r="1.49626" transform="rotate(90 27.8304 54.1642)" fill="white"></circle><circle cx="14.6644" cy="54.1642" r="1.49626" transform="rotate(90 14.6644 54.1642)" fill="white"></circle><circle cx="1.49642" cy="54.1642" r="1.49626" transform="rotate(90 1.49642 54.1642)" fill="white"></circle></g>
        </svg>
    </span>

  <div class="mt-5 sm:mt-10 lg:mt-0 col-span-1">
      <div class=" sm:space-y-8 text-white">
      <p className='text-blue-400 text-sm font-semibold wow animate__animated animate__fadeInUp ' data-wow-delay=".2s" >Built by Developers for Developers</p>
      <h2 className='text-left font-bold sm:leading-10 text-4xl  wow animate__animated animate__fadeInUp my-4 sm:my-0 wow animate__animated animate__fadeInUp ' data-wow-delay=".4s" >
      Trusted by enterprises, loved by developers </h2>
      <p className='text-white leading-7 wow animate__animated animate__fadeInUp ' data-wow-delay=".6s" >
      Celenity makes sending messages as easy and programmable as moving data. 
      Save engineering time with our unified messaging APIs and get up and running in minutes on our reliable, auto-scaling APIs with extensive documentations, complete API references and intuitive SDKs.
      </p>
      <a className="inline-flex justify-center items-center gap-x-3 text-center bg-blue-600 hover:bg-blue-800 hover:text-white border border-transparent text-sm lg:text-base text-white font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-white transition py-3 px-4 dark:focus:ring-offset-gray-800 wow animate__animated animate__fadeInUp my-10 " data-wow-delay=".8s" href="#">
Read the Developer Docs          <svg className="w-2.5 h-2.5" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </a>
      </div>
      </div>

      <div className='text-white col-span-1'>
   


<div className=' bg-[#0c2e4e]  h-[420px] px-4  py-2 rounded-lg wow animate__animated animate__bounceInUp' data-wow-delay=".2s">
{/* <div className='bg-[#231553] bg-gradient-to-r from-[#12235a] to-[#2e054d] h-[420px] px-10 py-8 rounded-3xl '> */}

<div className="w-100 custom-tab">

<div className='flex flex-row justify-start mb-4'>
<span className={` px-2 rounded-lg active  bg-[#052b73]  inline-block`}  href="javascript:void(0)" > Javascript </span>
<a className='mx-4'>  <ClipboardIcon className="h-6 w-6" aria-hidden="true" /></a>
</div>


      <div className="tab-content sm:px-3 py-4 leading-9 h-[320px] overflow-scroll  flex flex-row" >

<div className="w-8 flex flex-col text-sm leading-7"> 
<span className='text-[#55718d]'>1</span>
<span className='text-[#55718d]'>2</span>
<span className='text-[#55718d]'>3</span>
<span className='text-[#55718d]'>4</span>

</div>
    <div className='w-full  text-sm leading-7'>


    import &nbsp;<span className='syntax_keyword'>axios</span> &nbsp;from &nbsp;<span className='syntax_string'>'axios';</span> <br/>

<span className='syntax_function'> {`try {`} </span> <br/>
 <span className='syntax_default'>  <span className='syntax_keyword'>const</span> url  =  <span className='syntax_string'>  "https://api.wittyflow.com/v1/messages/send"</span>;` 
 <br/>
  <span className='syntax_keyword'>const</span> dataToSend <span className='syntax_operator'>=</span> <span className='syntax_keyword'>qs.</span><span className='syntax_function'>stringify</span> <span className='syntax_punctuation'>{ `({`}  </span> <br/>
from :  <span className='syntax_string'>"Your Approved SenderName"</span>, <br/>
   to :   [<span className='syntax_string'>'recipients'</span> ], <br/>
   message : <span className='syntax_string'>"Your message goes here.." <br/> </span>{ `});`} 
   <br/>

  <span className='syntax_keyword'>const</span> options = {`{`}<br/>
    headers : {`{`}<br/>
      "Content-Type" : <span className='syntax_string'>"application/json"</span>,<br/>
      Authorization : <span className='syntax_string'>`Bearer appId:appSecret`,</span><br/>
    {`}`},<br/>
    method : <span className='syntax_string'>"POST"</span>,<br/>
    data : <span className='syntax_keyword'>dataToSend</span>,<br/>
    url, <br/>
{`};`}
  <br/>
  <span className='syntax_function'>axios</span>(<span className='syntax_number'>options</span>)
    .<span className='syntax_function'>then</span>((<span className='syntax_number'>res</span> {`) => {`} <br/>
    {/* if (res.status === 200 || res.status === 202) {
        onCompleteCallback(res.data.data);
        //console.log(res.data.data);
      }

      // return
    })
    .catch((err) => {
      console.log("sending msg error", err);
      return err;
    });
} catch (err) {
  console.error(err);
}`*/} */}

</span> 

    </div>
            </div>
    </div>

{/* copy */}



{/* end copy */}

</div>
    </div>

  </div>

  <div class="max-w-[85rem] px-4 py-20 sm:px-6 lg:px-8 lg:py-6 mx-auto">

  {/* <!-- Grid --> */}
  <div class="grid items-center lg:grid-cols-12 gap-6 lg:gap-12 mt-12 relative">

    <div class="lg:col-span-4">
      {/* <!-- Stats --> */}
      <div class="lg:pr-6 xl:pr-12">
        <p class="text-6xl font-bold leading-10 text-blue-500 wow animate__animated animate__fadeInUp " data-wow-delay=".2s" >
          300M+ 
        
        </p>
        <p class="mt-2 sm:mt-3 text-gray-400 wow animate__animated animate__fadeInUp " data-wow-delay=".2s" >Messages delivered annually</p>
      </div>
      {/* <!-- End Stats --> */}
    </div>
    {/* <!-- End Col --> */}

    <div class="lg:col-span-8 relative lg:before:absolute lg:before:top-0 lg:before:-left-12 lg:before:w-px lg:before:h-full lg:before:bg-gray-200 lg:before:dark:bg-gray-700">
      <div class="grid gap-6 grid-cols-2 md:grid-cols-4 lg:grid-cols-3 sm:gap-8">
        {/* <!-- Stats --> */}
        <div>
          <p class="text-3xl font-semibold text-blue-500 wow animate__animated animate__fadeInUp " data-wow-delay=".4s" >99.99%</p>
          <p class="mt-1 text-gray-400">Message delivery rate</p>
        </div>
        {/* <!-- End Stats --> */}

        {/* <!-- Stats --> */}
        <div>
          <p class="text-3xl font-semibold text-blue-500 wow animate__animated animate__fadeInUp " data-wow-delay=".6s" >8K+</p>
          <p class="mt-1 text-gray-400">API Integrations</p>
        </div>
        {/* <!-- End Stats --> */}

        {/* <!-- Stats --> */}
        <div>
          <p class="text-3xl font-semibold text-blue-500 wow animate__animated animate__fadeInUp " data-wow-delay=".8s" >45K+</p>
          <p class="mt-1 text-gray-400 wow animate__animated animate__fadeInUp " data-wow-delay=".8s" >Businesses connected</p>
        </div>
        {/* <!-- End Stats --> */}
      </div>
    </div>
    {/* <!-- End Col --> */}
  </div>
  {/* <!-- End Grid --> */}
</div>

  </div>
    </div>
  )
}

export default Developers